/// <reference path="../../BaseNew/GAdmHromadnaOperaceBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class HromadnaOperaceAdmFunkcniMistoDenikSsl extends GContentBase {
        private hromadnaOperaceObj: HromadnaOperaceAdmFunkcniMistoDenikSslObj & GContent;
        private data: Gordic.AdmIsl.Interface.GAdmFunkcniMistoDenikSslReadDto[];
        private keys: string[];

        onContentReady() {
            this.hromadnaOperaceObj = $.extend(this as GContent, new HromadnaOperaceAdmFunkcniMistoDenikSslObj())
            this.hromadnaOperaceObj.createBase({
                title: "jres:33000623", //RC 33000623 : Hromadné přidání funkčních míst
                data: this.data,
                objectFields: ['sslden'],
                serviceCnt: "Gordic.Adm.WebControls.HromadnaOperaceAdmFunkcniMistoDenikSsl",
                keys: this.keys,
                contentId: "hromadnaOperaceAdmFunkcniMistoDenikSsl "
            })
        }
    }

    export class HromadnaOperaceAdmFunkcniMistoDenikSslObj extends GAdmHromadnaOperaceBase<Gordic.AdmIsl.Interface.GAdmFunkcniMistoDenikSslReadDto> {
        isFunkcniMisto: boolean

        createForm(cnt: GContent<IGContentBase, any>, contentDiv: JQuery<HTMLElement>, change: OGWizardChange) {
            var form = new Gordic.Forms.Form({ layoutDescriptor: "L1M1S1" })
                .addRow("jres:33000100").addField("gselectbox", Gordic.Prefabs.Select.sslsden(), {
                    name: "sslden",
                    model: "model.sslden=value.sslden",
                    dropdown: false,
                    multi: true,
                    itemWidth: "",
                    initialValue: this.options.data.map((value) => ({ sslden: value.sslden })),
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                }).addRow("jres:33000093").addField("gselectbox", Gordic.Prefabs.Select.ginsfun(), {
                    name: "ixs_fun",
                    model: "model.ixs_fun=value.ixs_fun;model.ixs_fun_txt<=value.nazev",
                    dropdown: false,
                    multi: true,
                    itemWidth: "",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                }).addRow("jres:32131030").addField("gselectbox", Gordic.Prefabs.Select.gincakt(), {
                    name: "aktivita",
                    model: "model.aktivita=value.aktivita;model.aktivita_txt<=value.aktivita_txt",
                    initialValue: { aktivita: 100 },
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                })
            $("<div>").appendTo(contentDiv).gform("createFrom", form);
        }

        createDefineGridData(formData: any): any {
            var cartesianResult = this.createCartesianProduct2D(this.transformDataToArrayObject(formData, ["sslden"]), this.transformDataToArrayObject(formData, ["ixs_fun", "ixs_fun_txt"]));
            var resultArray: any = [];
            cartesianResult.forEach((item) => {
                var data = {
                    sslden: item[0]["sslden"],
                    ixs_fun: item[1]["ixs_fun"],
                    ixs_fun_txt: item[1]["ixs_fun_txt"],
                    aktivita: formData['aktivita']
                }
                resultArray.push(data);
            })
            return resultArray;
        }

        createGridFormat(gridFormat: Gordic.Data.GridFormat): Gordic.Data.GridFormat {
            this.createAktivitaColumn(gridFormat);
            gridFormat.addTextColumn({
                caption: "jres:29808057",
                name: "sslden"
            }).addTextColumn({
                caption: "jres:29802552",
                name: "ixs_fun_txt"
            })
            return gridFormat;
        }

        // Volání zatím přes CSharp (přes ISL zatím nevím jak na hromadné operace)
        saveData(data: any[]): JQueryPromise<any> {
            var saveData: Gordic.AdmIsl.Interface.GAdmFunkcniMistoDenikSslSaveDto[] = [];
            data.forEach((item) => {
                saveData.push({
                    sslden: item['sslden'],
                    ixs_fun: item['ixs_fun'],
                    subrada: item['subrada'],
                    aktivita: item['aktivita'],
                    NewRecord: true
                })
            })
            return this.getServiceCnt().call("SaveHromadne", { saveData: saveData }).done((results) => {
                this.createResultData(results)
            })
        }

        validateRows(data: any): Gordic.Validators.GridError[] {
            return [];
        }

        testExistMethod(data: any[]): JQueryPromise<any> {
            return $.Deferred()
        }
    }
}